import React, { forwardRef } from "react";
import ButtonAction from "@streeteasy/design-system/button-action";
import actionElements from "@streeteasy/design-system/constants/actionElements";
import componentSizes from "@streeteasy/design-system/constants/componentSizes";
import { bool, func, node, oneOf } from "prop-types";

/**
 * @deprecated use the ButtonAction component instead
 */

const Button = forwardRef(({ disabled, isLoading, onClick, ...props }, ref) => (
  <ButtonAction
    ref={ref}
    {...props}
    disabled={disabled}
    element={actionElements.button}
    isLoading={isLoading}
    onClick={onClick}
  />
));

Button.displayName = "Button";

Button.propTypes = {
  children: node.isRequired,
  disabled: bool,
  /**
   * When this prop is true, Button will show a loading state.
   *
   * This will also disable a Button. This might be useful if we
   * want to prevent user from interacting with form while we processing server request.
   */
  isLoading: bool,
  onClick: func,
  /**
   * Determines the size of the Button.
   *
   * Values for the size prop are imported from the componentSizes module.
   *
   * ```
   * import Button from "./Button";
   * ```
   * ```
   * import componentSizes from "./path/to/componentSizes";
   *```
   *```
   * export const MyButton = () => <Button size={componentSizes.SM}>Next</Button>;
   * ```
   * */
  size: oneOf([componentSizes.SM, componentSizes.MD, componentSizes.LG])
};

Button.defaultProps = {
  disabled: false,
  isLoading: false,
  onClick: () => {},
  size: componentSizes.MD
};

export default Button;
